import { render, staticRenderFns } from "./InformList.vue?vue&type=template&id=b4d0c3e4&"
import script from "./InformList.vue?vue&type=script&lang=js&"
export * from "./InformList.vue?vue&type=script&lang=js&"
import style0 from "./InformList.vue?vue&type=style&index=0&id=b4d0c3e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports